import { UserPersonRepository } from "@domain/user-person/repositories/user-person.repository";
import { UserPersonRepositoryService } from "../repositories/user-person.service";

export const UserPersonProvider = [
    {
      provide: UserPersonRepository,
      useClass: UserPersonRepositoryService,
    },
  ];
  